import { FC } from 'react';

import Content from './Content';
import { GridContentProps } from './type';

const CenteredContent: FC<GridContentProps> = ({ children, sx }) => (
  <Content sx={{ ...sx, textAlign: 'center' }}>{children}</Content>
);

export default CenteredContent;
